import { IconNG, IconSpinner, IconSpinnerOverlay } from '../../../Icon'
import { Container } from '../../Container'

import { preparedIconList } from './IconList.utils'

import * as styles from './IconList.module.css'

function IconList() {
  const icons = preparedIconList()

  return (
    <div>
      {icons.map(({ Icon, name, sizes }) => {
        return (
          <Container
            contentClassName={styles.container}
            key={name}
            label={name}
          >
            {sizes.map(size => (
              <Container className={styles.sizes} key={size} label={size}>
                <IconNG Icon={Icon} size={Number(size)} />
              </Container>
            ))}
          </Container>
        )
      })}

      <Container label='IconSpinner component'>
        <IconSpinner />
      </Container>

      <Container label='IconSpinnerOverlay component'>
        <IconSpinnerOverlay />
      </Container>
    </div>
  )
}

export default IconList
